import React from 'react'
import {Chart, ZoomButtons} from 'react-stockcharts'
import LineSeries from '../LineSeries'
import {XAxis, YAxis} from 'react-stockcharts/lib/axes'
import {
  MouseCoordinateX,
  CurrentCoordinate,
  EdgeIndicator
} from 'react-stockcharts/lib/coordinates'
import {SingleValueTooltip} from 'react-stockcharts/lib/tooltip'
import {timeFormat} from 'd3-time-format'
import {schemeCategory10} from 'd3-scale'
import uniqid from 'uniqid'

import {format, getExtents} from '../functions'

/* eslint-disable */
const getContents = (chart_id, chart_index, format, data, interpolation, getTextWidth, width, list) => {
  let contents = []
  let nextLabelHorizontalOffset = 20
  let nextLabelVerticalOffset = 20
  const keys = list.find(el => el.chart_id === chart_id)?.names
  const chartIndicatorsYAccessor = (d, name) => {
    return d.indicators && d.indicators[chart_id] ? d.indicators[chart_id][name] : undefined
  }
  keys.map((name, index) => {
    const color = schemeCategory10[chart_index*2+index+1]
    const max = data?.reduce((a, b) => {
      const previous = typeof a === 'object' ? 0 : a
      const current = b.indicators?.[chart_id]?.[name] || 0
      return Math.max(previous, current)
    }, 0) || 0
    const textWidth = getTextWidth(`${name}: ${typeof max === 'number' ? max.toFixed(2) : '0.00'}`)
    if (nextLabelHorizontalOffset + textWidth > width) {
      nextLabelHorizontalOffset = 20
      nextLabelVerticalOffset += 20
    }
    contents.push(
      <g key={uniqid()}>
        <LineSeries
          yAccessor={d => chartIndicatorsYAccessor(d, name)}
          interpolation={interpolation}
          stroke={color}
          strokeWidth={2}
          connectNulls={true}
          target={['indicators', chart_id, name]}
        />
        <CurrentCoordinate
          yAccessor={d => chartIndicatorsYAccessor(d, name)}
          fill={color}
        />
        <SingleValueTooltip
          key={name}
          yLabel={name}
          valueFill='black'
          fontSize={12}
          labelFill={color}
          yAccessor={d => chartIndicatorsYAccessor(d, name)}
          origin={[nextLabelHorizontalOffset, nextLabelVerticalOffset]}
          yDisplayFormat={format}
        />
      </g>
    )
    nextLabelHorizontalOffset += textWidth + 20
  })
  return contents
}

const getYExtents = (chart_id, data, consts, list) => {
  const constVal = consts[chart_id]
  const names = list.find(el => el.chart_id === chart_id)?.names
  return getExtents(data, names, chart_id, constVal)
}
/* eslint-enable */

const getOrigin = (index, pnlOffset, priceOffset) => {
  return [0, 250*index + pnlOffset + priceOffset]
}

export const getIndicatorsCharts = (
  data,
  consts,
  units,
  interpolation,
  pnlOffset,
  priceOffset,
  width,
  margin,
  getTextWidth,
  reset,
  frequency,
  mouseCoordinateWidth,
  list
) => {
  let charts = []
  const keys = list.map(el => el.chart_id)
  keys.map((chart_id, index) => {
    const {unit, location} = units[chart_id] || {}
    const tickFormat = format(unit, location)
    charts.push(
      <Chart
        key={chart_id}
        id={chart_id}
        yExtents={getYExtents(chart_id, data, consts, list)}
        height={250}
        origin={() => getOrigin(index, pnlOffset, priceOffset)}
      >
        <ZoomButtons onReset={reset}/>
        <rect width={width - margin.left - margin.right}
          height={250}
          x={1}
          stroke='#000000'
          strokeOpacity={0.3}
          strokeWidth={1}
          fill={index%2 === 0 ? 'none' : 'rgba(80,80,120,0.1)'}
        />
        <YAxis
          axisAt={index%2 === 0 ? 'right' : 'left'}
          orient={index%2 === 0 ? 'right' : 'left'}
          ticks={5}
          tickFormat={tickFormat}
          tickStrokeOpacity={0.1}
          innerTickSize={-(width - margin.left - margin.right)}
        />
        <XAxis
          axisAt='bottom'
          orient='bottom'
          opacity={0}
          fontSize={index === keys.length - 1 ? 12 : 0}
          tickStrokeOpacity={0.1}
          innerTickSize={-250}
        />
        {!!consts[chart_id] &&
          <g>
            <EdgeIndicator
              itemType='first'
              orient='left'
              edgeAt='left'
              displayFormat={format()}
              yAccessor={() => consts[chart_id]}
              lineStrokeDasharray='Solid'
              fill={'gray'}
            />
          </g>
        }
        {getContents(chart_id, index, tickFormat, data, interpolation, getTextWidth, width, list).map(contents => contents)}

        <MouseCoordinateX
          at='bottom'
          orient='bottom'
          displayFormat={timeFormat(frequency)}
          rectWidth={mouseCoordinateWidth}
        />
      </Chart>
    )
  })
  return charts
}
